<div class="modal-header py-2">
	<h5 class="modal-title">Filter</h5>
	<button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
	<!-- Scope-Switch (nur ohne Projekt sichtbar) -->
	<div class="scope-section mb-3" *ngIf="showScopeSwitch">
		<div class="input-group input-group-sm">
			<span class="input-group-text">Bereich</span>
			<button type="button" class="btn flex-fill"
					[class.btn-secondary]="scope === 'visible'"
					[class.btn-outline-secondary]="scope !== 'visible'"
					(click)="setScope('visible')">
				<i class="bi bi-window"></i> Kartenausschnitt
			</button>
			<button type="button" class="btn flex-fill"
					[class.btn-secondary]="scope === 'all'"
					[class.btn-outline-secondary]="scope !== 'all'"
					(click)="setScope('all')">
				<i class="bi bi-globe"></i> Alle
			</button>
		</div>
	</div>

	<!-- Neuer Filter -->
	<div class="new-filter-section">
		<button class="btn btn-outline-secondary btn-sm" (click)="showNewFilterInput = true" *ngIf="!showNewFilterInput">
			<i class="bi bi-plus-lg"></i> Neuer Filter...
		</button>
		<div class="new-filter-input" *ngIf="showNewFilterInput">
			<input type="text" class="form-control form-control-sm"
				   placeholder="Filtername eingeben..."
				   [(ngModel)]="newFilterName"
				   (keyup.enter)="addNewFilterIfValid(); showNewFilterInput = false"
				   (keyup.escape)="showNewFilterInput = false; newFilterName = ''"
				   #newFilterInput>
			<button class="btn btn-outline-primary btn-xs"
					[disabled]="!canAddNewFilter()"
					(click)="addNewFilterIfValid(); showNewFilterInput = false">
				<i class="bi bi-check-lg"></i>
			</button>
			<button class="btn btn-outline-secondary btn-xs"
					(click)="showNewFilterInput = false; newFilterName = ''">
				<i class="bi bi-x-lg"></i>
			</button>
		</div>
	</div>

	<!-- Filter-Auswahl -->
	<div class="filter-header" *ngIf="hasFilters()">
		<select class="form-select form-select-sm"
				[(ngModel)]="name"
				(ngModelChange)="filterChanged($event)">
			<option *ngFor="let f of filters" [value]="f">{{f}}</option>
		</select>
		<span class="delete-btn-wrapper" [title]="getDeleteTooltip()" (mouseenter)="refreshUsedFilters()">
			<button class="btn btn-outline-danger btn-xs"
					[disabled]="!filters || filters.length === 0 || isFilterInUse(name)"
					(click)="deleteFilter()">
				<i class="bi bi-trash"></i>
			</button>
		</span>
	</div>

	<!-- Bedingungen -->
	<div class="conditions-card" *ngIf="conditions">
		<div class="card-body">
			<!-- Keine Bedingungen -->
			<div *ngIf="!conditions.conditions || conditions.conditions.length === 0" class="no-conditions">
				Keine Bedingungen definiert
			</div>

			<!-- Bestehende Bedingungen -->
			<ng-container *ngIf="conditions.conditions && conditions.conditions.length > 0">
				<ng-container *ngFor="let c of conditions.conditions; let i = index; let last = last; trackBy: trackByConditionIndex">
					<div class="condition-row">
						<select class="form-select condition-field-select"
								[ngModel]="c.value"
								(ngModelChange)="fieldChangedForCondition(i, $event)">
							<option *ngFor="let value of keysOf(Values)" [value]="value">{{value}}</option>
						</select>
						<select class="form-select condition-operator"
								[ngModel]="c.opName"
								(ngModelChange)="operatorChangedForCondition(i, $event)">
							<option *ngFor="let op of Operators[c.type] | keyvalue" [value]="op.key">
								{{opString(op.value)}}
							</option>
						</select>
						<div class="condition-args">
							<input *ngFor="let a of c.args; let j = index; trackBy: trackByArgIndex"
								   type="text"
								   class="form-control"
								   [ngModel]="c.args[j]"
								   (ngModelChange)="argumentChanged($event, i, j)"
								   (blur)="saveConditions()"
								   (keyup.enter)="applyFilter()">
						</div>
						<button class="btn btn-outline-danger btn-xs"
								(click)="deleteCondition(i)"
								title="Bedingung löschen">
							<i class="bi bi-x-lg"></i>
						</button>
					</div>
					<!-- Verbindungsoperator zwischen den Zeilen -->
					<div class="condition-connector" *ngIf="!last">
						<select class="form-select form-select-sm"
								[(ngModel)]="conditions.type"
								(ngModelChange)="typeChanged($event)">
							<option [value]="ExpressionType.AND">{{ExpressionType.AND}}</option>
							<option [value]="ExpressionType.OR">{{ExpressionType.OR}}</option>
						</select>
					</div>
				</ng-container>
			</ng-container>

			<!-- Neue Bedingung hinzufügen -->
			<div class="new-condition-row">
				<div class="new-condition-selects">
					<select class="form-select"
							[(ngModel)]="newCondition.value"
							(ngModelChange)="onValueChanged()">
						<option value="">Feld...</option>
						<option *ngFor="let value of keysOf(Values)" [value]="value">{{value}}</option>
					</select>
					<select *ngIf="newCondition.value"
							class="form-select"
							[(ngModel)]="newCondition.opName"
							(ngModelChange)="onOperatorChanged()">
						<option value="">Operator...</option>
						<option *ngFor="let op of Operators[Values[newCondition.value].type] | keyvalue" [value]="op.key">
							{{opString(op.value)}}
						</option>
					</select>
				</div>
				<div class="condition-args" *ngIf="newArgs.length > 0">
					<input *ngFor="let a of newArgs; let i = index; trackBy: trackByIndex"
						   type="text"
						   class="form-control"
						   placeholder="Wert..."
						   [(ngModel)]="newArgs[i]"
						   (keyup.enter)="addNewCondition(); applyFilter()">
				</div>
				<button class="btn btn-outline-secondary btn-xs"
						[disabled]="!canAddNewCondition()"
						(click)="addNewCondition()"
						title="Bedingung hinzufügen">
					<i class="bi bi-plus-lg"></i>
				</button>
			</div>
		</div>
	</div>

	<!-- Kein Filter vorhanden -->
	<div *ngIf="!conditions" class="no-filter">
		Erstellen Sie einen neuen Filter
	</div>
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-outline-primary" [disabled]="!canApply()" (click)="applyFilter()">
		<i class="bi bi-funnel"></i> Anwenden
	</button>
	<button type="button" class="btn btn-primary" [disabled]="!canApply()" (click)="applyFilter(); onClose()">
		<i class="bi bi-funnel-fill"></i> Anwenden &amp; Schließen
	</button>
</div>
